(function() {
var GarageEntriesFormGenericEntryForm,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

GarageEntriesFormGenericEntryForm = (function() {
  function GarageEntriesFormGenericEntryForm() {
    this.setup_listeners = bind(this.setup_listeners, this);
    console.log("GarageEntriesFormGenericEntryForm constructor()");
    this.setup_listeners();
  }

  GarageEntriesFormGenericEntryForm.prototype.setup_listeners = function() {
    $(document).off("click", ".set_garage_item[data-garage-item] a.delete_garage_item_button");
    return $(document).on("click", ".set_garage_item[data-garage-item] a.delete_garage_item_button", (function(_this) {
      return function(e) {
        var $garage_item_container, _garage_item_id, _series_equipment_type_id;
        console.log("lickced");
        e.preventDefault();
        $garage_item_container = $(e.target).closest(".set_garage_item");
        _garage_item_id = $garage_item_container.data("garage-item");
        _series_equipment_type_id = $garage_item_container.data("series-equipment-type");
        return _this.remove_item_from_series_equipment_type(_series_equipment_type_id, _garage_item_id);
      };
    })(this));
  };

  GarageEntriesFormGenericEntryForm.prototype.add_item_to_series_equipment_type = function(series_equipment_type_id, garage_item_id) {
    var $series_equipment_type_selection_input, _current_items;
    $series_equipment_type_selection_input = $("#vehicle_set_" + series_equipment_type_id + " .set_selection input");
    _current_items = $series_equipment_type_selection_input.val();
    if (_current_items.length > 0 && !(_current_items.indexOf("" + garage_item_id) !== -1)) {
      _current_items = _current_items + ("," + garage_item_id);
    } else {
      _current_items = garage_item_id;
    }
    $series_equipment_type_selection_input.val(_current_items);
    return window.alpha_oms_utils.submit_form("new_event_entry");
  };

  GarageEntriesFormGenericEntryForm.prototype.remove_item_from_series_equipment_type = function(series_equipment_type_id, garage_item_id) {
    var $series_equipment_type_selection_input, _current_items, _items_array, _new_items;
    $series_equipment_type_selection_input = $("#vehicle_set_" + series_equipment_type_id + " .set_selection input");
    _current_items = $series_equipment_type_selection_input.val();
    _items_array = _current_items.split(",");
    _new_items = _items_array.filter(function(item) {
      return +item !== +garage_item_id;
    });
    $series_equipment_type_selection_input.val(_new_items.join(","));
    return window.alpha_oms_utils.submit_form("new_event_entry");
  };

  return GarageEntriesFormGenericEntryForm;

})();

window.alpha_oms.garage_entries_gef_form_constructor = GarageEntriesFormGenericEntryForm;

}).call(window);
